import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { GetApprovedRegionsQueryResponse, GetApprovedRegionsQueryParams } from "../../types/GetApprovedRegions";

/**
     * @link /api/credit-flow-backend/private/v1/regions
     */
export async function getApprovedRegions (params: GetApprovedRegionsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<GetApprovedRegionsQueryResponse>["data"]> {
    const { data: resData } = await client<GetApprovedRegionsQueryResponse>({
        method: "get",
        url: `/api/credit-flow-backend/private/v1/regions`,
        params,
        ...options
    });
    
    return resData;
};